module.exports = __webpack_public_path__ + "static/media/img33.a2120046.jpg";